export const getLoadViewsData = ({ fieldsObject, filters = null }) => {
  if (!fieldsObject) return null;
  const fieldsType = [
    "one2many",
    "many2one",
    "many2many",
    "boolean",
    "binary",
    "char",
    // "selection",
    "float",
    "text",
    "integer",
  ];

  const filteredObjects = {};
  return filters
    ? Object.keys(fieldsObject).filter((key) => {
        let filterResult = true;

        Object.keys(filters).forEach((filterKey) => {
          if (
            typeof fieldsObject[key][filterKey] !== "undefined" &&
            filters[filterKey] !== fieldsObject[key][filterKey]
          ) {
            filterResult = false;
          }
        });
        return filterResult;
      })
    : Object.keys(fieldsObject);
};

export const getFormattedResponse = ({ payload, formFieldsList }) => {
  const updatedPayload = {};
  try {
    formFieldsList?.forEach((key) => {
      if (typeof payload[key] !== "undefined") {
        updatedPayload[key] = payload[key];
      }
    });
  } catch (error) {
    return payload;
  }
  return updatedPayload;
};
